var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-autocomplete",
    {
      class: { "gray--text text--lighten-1": _vm.disabled },
      attrs: {
        color: "secondary",
        "no-data-text": "Nenhum resultado encontrado",
        disabled: _vm.disabled,
        value: _vm.value,
        items: _vm.items,
        "search-input": _vm.search,
        "item-text": _vm.onText,
        "item-value": _vm.onValue,
        label: _vm.label,
        placeholder: _vm.placeholder,
        "error-messages": _vm.currentError,
        multiple: _vm.multiple,
        "return-object": _vm.returnObject,
        loading: _vm.loading,
      },
      on: {
        "update:searchInput": function ($event) {
          _vm.search = $event
        },
        "update:search-input": function ($event) {
          _vm.search = $event
        },
        change: _vm.change,
      },
    },
    [
      _c(
        "span",
        {
          class: {
            "gray--text text--lighten-1": _vm.disabled,
            "required-field": _vm.isRequired,
          },
          attrs: { slot: "label" },
          slot: "label",
        },
        [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }